import React from 'react';
import styled, { css } from 'styled-components';
import * as PropTypes from 'prop-types';

import { globalTheme } from '@cld/component-theme';
import { asStyledComponent, WrapTextChildren } from '@cld/component-enhancer';

import { sizeVariant } from './theme';

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;

  font-size: ${sizeVariant((variant) => variant.font)};

  > *:first-child {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: ${globalTheme.spacing.xs};

    overflow: hidden;

    ${sizeVariant(
      (variant) => css`
        width: ${variant.icon};
        min-width: ${variant.icon};
        height: ${variant.icon};
      `
    )}

    > *:first-child {
      max-width: 100%;
      max-height: 100%;
    }
  }

  > *:nth-child(2) {
    flex-grow: 1;
  }

  * {
    min-width: 0;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;

    line-height: ${sizeVariant((variant) => variant.icon)};
  }
`;

export const ListItemLayout = ({ size = 'md', children, ...props }) => (
  <Wrapper size={size} {...props}>
    <WrapTextChildren>{children}</WrapTextChildren>
  </Wrapper>
);

ListItemLayout.propTypes = {
  size: PropTypes.string,
};

export default asStyledComponent(ListItemLayout);
